<template>
  <div class="already-receive-list">
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="ERP订单编号:" prop="ERPNumber">
        <el-input v-model.trim="searchForm.ERPNumber" placeholder="请输入ERP订单编号" />
      </el-form-item>
      <el-form-item label="合同编号:" prop="ContractNumber">
        <el-input v-model.trim="searchForm.ContractNumber" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" placeholder="请输入合同编号" @blur="salaryChange" />
      </el-form-item>
      <el-form-item label="发货单号:" prop="ReceiptNumber">
        <el-input v-model.trim="searchForm.ReceiptNumber" placeholder="请输入发货单号" />
      </el-form-item>
      <el-form-item label="发货时间:" prop="BeginReceiptDate">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.BeginReceiptDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.EndReceiptDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="tableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="ERPNumber" label="ERP订单编号" align="left" width="130" />
        <el-table-column prop="ContractNumber" label="合同编号" align="left" width="130" />
        <el-table-column prop="ObjectName" label="项目名称" align="left" min-width="230" />
        <el-table-column prop="ReceiptAddress" label="收货地址" align="left" min-width="150" />
        <el-table-column prop="IntegratorsName" label="首级集成商名称" align="left" min-width="150" />
        <el-table-column prop="LogisticsCompany" label="物流公司" align="left" width="150" />
        <el-table-column prop="ReceiptNumber" label="发货单号" align="left" width="130">
          <template v-slot="{row}">
            <el-button type="text" @click="detailProductList(row)">
              {{ row.ReceiptNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="ReceiptDate" label="发货日期" align="left" width="100" />
        <el-table-column prop="FreightNumber" label="货运单号" align="left" width="130" />
        <el-table-column label="回单" align="left" width="90">
          <template v-slot="{row}">
            <el-button type="text" @click="toReceiptList(row)">
              查看及上传
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="StateClass" label="状态信息" width="110" align="left" />
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="发货产品清单" :visible.sync="receiptProductVisible" width="800px">
      <delivery-receipt-product-list
        v-if="receiptProductVisible"
        :receipt-number="receiptNumber"
        :contract-code="contractCode"
        :order-number="orderNumber"
      />
    </el-dialog>
    <el-dialog title="回单信息" :visible.sync="receiptVisible" width="700px">
      <receipt-list v-if="receiptVisible" :receipt-form="receiptForm" :is-show="isShow" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="receiptVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getDeliveryReceiptList, comfirmReceipt } from '@/API/index.js';
import deliveryReceiptProductList from './deliveryReceiptProductList';
import receiptList from './receiptList';
import eventBus from '@/libs/eventBus.js';
export default {
  name: 'AlreadyReceiveList',
  data () {
    return {
      tableLoading: false,
      receiptProductVisible: false,
      searchForm: {
        ERPNumber: '',
        ContractNumber: '',
        ReceiptNumber: '',
        BeginReceiptDate: '',
        EndReceiptDate: ''
      },
      tableData: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 100
      },
      receiptNumber: '',
      contractCode: '',
      orderNumber: '',
      receiptVisible: false,
      receiptForm: {},
      isShow: false
    };
  },
  components: {
    deliveryReceiptProductList, receiptList
  },
  methods: {
    // blur
    salaryChange (e) {
      this.searchForm.ContractNumber = (e.target.value || '').trim();
    },
    initData () {
      this.tableLoading = true;
      let params = {
        StateClass: 2,
        ERPNumber: this.searchForm.ERPNumber,
        ContractNumber: this.searchForm.ContractNumber,
        ReceiptNumber: this.searchForm.ReceiptNumber,
        BeginReceiptDate: this.searchForm.BeginReceiptDate,
        EndReceiptDate: this.searchForm.EndReceiptDate,
        PageSize: this.page.pageSize,
        PageIndex: this.page.currentPage - 1
      };
      getDeliveryReceiptList(params).then((res) => {
        let json = res.data;
        if (json.status === '200' && json.data.dt) {
          this.tableLoading = false;
          this.page.currentPage = json.data.PageIndex + 1;
          this.page.total = json.data.TotalCount;
          this.tableData = json.data.dt;
        } else {
          this.tableData = [];
          this.page.currentPage = 1;
          this.page.total = 0;
        }
      }).catch((res) => {
        this.tableLoading = false;
      });
    },
    resetForm () {
      this.$refs['searchForm'].resetFields();
      this.searchForm.EndReceiptDate = '';
      this.page.currentPage = 1;
      this.initData();
    },
    doSearch () {
      this.page.currentPage = 1;
      this.initData();
    },
    comfirmReceipt (row) {
      this.$confirm('确认是否收货?', '提示', {
        confirmButtonText: '收货',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          ReceiptNumber: row.ReceiptNumber,
          State: '2'
        };
        comfirmReceipt(params).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message({
              type: 'success',
              message: '确认收货成功!'
            });
            this.searchForm.currentPage = 1;
            this.initData();
          }
        }).catch((res) => {
          this.$message({
            type: 'warning',
            message: '确认收货失败!'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    detailProductList (row) {
      this.receiptProductVisible = true;
      this.receiptNumber = row.ReceiptNumber;
      this.contractCode = row.ContractNumber;
      this.orderNumber = row.ERPNumber;
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.initData();
    },
    handerCurrentChange () {
      this.initData();
    },
    pickerOptions () {

    },
    toReceiptList (row) {
      this.receiptVisible = true;
      this.receiptForm = row;
    }
  },
  mounted () {
    this.initData();
    eventBus.$on('changescom', () => {
      this.initData();
    });
  }
};
</script>

<style scoped>

</style>
